<template>
  <v-container fluid>
  <section>
    <data-table
      :headers="headers"
      :items="quotations"
      commit="SET_BEST_SALE"
      :viewItem="viewItem"
      :editItem="printQuotation"
      :deleteItem="editItem"
    >
      <div slot="activator" class="row mb-4">
        <div class="col-12">
          <div class="d-flex align-center justify-space-between flex-wrap gap-3">
            <v-card-title
              class="py-0 pl-0 mb-0 ps-doc-title"
              :class="{ 'ps-dark-mode-value': $vuetify.theme.dark }"
            >
              {{ $t("document") }}
            </v-card-title>
            <v-btn-toggle
              v-model="status_filter"
              mandatory
              dense
              class="ps-status-toggle"
            >
              <v-btn
                v-for="(val, i) in status_list"
                :key="i"
                small
                :value="val.value"
              >
                {{ $t(val.text) }}
              </v-btn>
            </v-btn-toggle>
          </div>
        </div>

        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-2">
          <TextSelect
            :dense="true"
            :placeholder="false"
            :items="documents"
            v-model="document"
            itemText="text"
            itemValue="id"
          />
        </div>
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 text-right offset-lg-3">
          <TextSearch
            v-model="search"
            @search="fetchItem()"
            @onClear="
              search = '';
              fetchItem();
            "
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 text-right">
          <v-btn
            min-width="auto"
            depressed
            color="primary"
            class="white--text btn-primary-brand"
            @click="newItem"
          >
            <v-icon left small>fal fa-plus</v-icon>
            {{ $t("add_document") }}
          </v-btn>
        </div>
      </div>
    </data-table>
    <app-custom-dialog
      v-model="dialog"
      :footer="false"
      width="750"
      title="description"
      @submit="submitForm"
    >
      <div slot="activator">
        <AppDetail :item="form" @btnAction="btnAction" />
      </div>
    </app-custom-dialog>
    <app-custom-dialog
      v-model="dialogAdd"
      :footer="true"
      :title="update ? 'update_document' : 'add_document'"
      @submit="submitForm"
      :showSubmitIcon="false"
      submitText="choose_product"
    >
      <div slot="activator">
        <v-tabs
          v-model="form.document"
          color="primary"
          grow
          background-color="transparent"
        >
          <v-tab
            v-for="(val, i) in documents"
            :key="i"
            class="text-capitalize"
            :tab-value="val"
          >
            {{ val.text }}
          </v-tab>
        </v-tabs>
        <v-divider class="mt-0" />

        <v-row align="center">
          <v-col cols="11">
            <TextSelect
              label="choose_customer"
              v-model="form.customer_id"
              itemValue="id"
              text="first_name"
              :items="customers"
            />
          </v-col>
          <v-col cols="1">
            <v-btn icon color="primary" class="mt-4" to="/manage-customers">
              <v-icon>fal fa-plus-circle</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <CheckBox v-model="form.include_tax" label="tax_include" />
        <CheckBox
          v-if="form.document.value === 'quotation'"
          v-model="showExpiredDate"
          label="show_expired"
        />
        <template>
          <div class="pt-2 font-weight-medium mb-1">{{ $t("choose_currency") }}</div>
          <div class="br-tabs mb-2">
            <div
              v-for="(val, i) in currencies"
              :key="i"
              class="br-tab"
              :class="{ 'br-tab--active': form.currency === val.name }"
              @click="form.currency = val.name"
            >
              {{ val.name }}
            </div>
          </div>
        </template>
        <DatePicker
          v-if="showExpiredDate"
          label="expired_date"
          v-model="form.expiry_date"
        />
        <TextArea
          v-model="form.note"
          label="noted"
          outlined
          multi-line
          :rows="3"
        />
      </div>
    </app-custom-dialog>
    <!-- AppLoading -->
    <app-loading :overlay="overlay" />
    <app-print v-show="print" :item="form" :accounts="accounts" />
  </section>
</v-container>
</template>

<script>
import DataTable from "@/components/DataTable";
import { mapGetters, mapActions, mapMutations } from "vuex";
import { quatationHead } from "@/utils/head";
import TTextField from "@/components/global/TextField";
import CheckBox from "@/components/global/CheckBox";
import { success } from "@/controllers/alert";
import TextSelect from "@/components/global/TextSelect";
import { mainStore } from "@/stores/modules/cart";
import AppDetail from "@/components/documents/detail.vue";
import AppPrint from "@/components/documents/print";
import TextArea from "@/components/global/TextArea";

export default {
  data: () => ({
    print: false,
    update: false,
    overlay: false,
    showExpiredDate: false,
    search: "",
    dialogAdd: false,
    dialog: false,
    defineStore: mainStore(),
    document: {
      id: 1,
      text: "quotation",
      value: "quotation",
    },
    form: {
      document: {
        id: 1,
        text: "quotation",
        value: "quotation",
      },
      currency: "lak",
      customer_id: null,
      customer: {},
      store: {
        thb: 0,
        usd: 0,
      },
    },
    status_filter: "all",
    status_list: [
      { text: "all", value: "all" },
      { text: "pending", value: "pending" },
      { text: "approved", value: "accepted" },
      { text: "rejected", value: "rejected" },
    ],
    accounts: [],
  }),
  async created() {
    await this.fetchItem();
  },
  mounted() {
    this.fetchBankAccount();
  },
  components: {
    DataTable,
    TTextField,
    AppDetail,
    TextSelect,
    CheckBox,
    AppPrint,
    TextArea,
  },

  computed: {
    ...mapGetters({
      quotations: "index/quotations",
      customers: "index/customers",
      currencies: "index/currencies",
      tax: "auth/tax",
    }),

    titleStatus() {
      return this.update ? "update" : "new_data";
    },
    headers() {
      return quatationHead(this);
    },
    documents() {
      return [
        {
          id: 1,
          text: this.$t("quotation"),
          value: "quotation",
        },
        {
          id: 2,
          text: this.$t("invoice"),
          value: "invoice",
        },
      ];
    },
  },

  watch: {
    status_filter() {
      this.fetchItem();
    },
    document(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.fetchItem();
      }
    },
  },

  methods: {
    ...mapActions({
      fetch: "index/fetch",
    }),
    ...mapMutations({
      SET_NEW_QUOTATION: "index/SET_NEW_QUOTATION",
    }),
    async fetchBankAccount() {
      try {
        const { data } = await this.$http.get("/bank_accounts");
        this.accounts = data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchItem() {
      const params = `q=${this.search}&status=${this.status_filter}&document=${this.document.value}`;
      const body = {
        that: this,
        url: `quotation?${params}`,
        commit: "SET_QUOTATIONS",
      };
      await this.fetch(body);
    },
    async fetchCustomer() {
      const body = {
        that: this,
        url: "customers",
        commit: "SET_CUSTOMER",
      };
      await this.fetch(body);
    },
    async setDefault() {
      this.form = {
        document: {
          id: 1,
          text: "quotation",
          value: "quotation",
        },
        currency: "lak",
        customer_id: null,
        customer: {},
        store: {
          thb: 0,
          usd: 0,
        },
      };
    },
    async newItem() {
      this.setDefault();
      await this.fetchItem();
      await this.fetchCustomer();
      this.update = false;
      this.dialogAdd = !this.dialogAdd;
    },
    async printQuotation({ id }) {
      try {
        const { data } = await this.$http.get(`quotation_detail/${id}`);
        if (data.status) {
          this.form = data.data;
          setTimeout(() => {
            this.$htmlToPaper("quotationPrint");
          }, 500);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async editItem({ id }) {
      try {
        const { data } = await this.$http.get(`quotation_detail/${id}`);
        if (data.status) {
          await this.fetchCustomer();
          if (data.data.expiry_date) {
            this.showExpiredDate = true;
          }
          this.form = {
            update: true,
            id: data.data.id,
            customer_id: data.data.customer,
            expiry_date: data.data.expiry_date,
            note: data.data.noted,
            include_tax: data.data.include_tax ? true : false,
            customer: { id: data.data.customer },
            store: data.data.store,
            document: {
              id: data.data.document === "quotation" ? 1 : 2,
              text: data.data.document,
              value: data.data.document,
            },
          };
          this.dialogAdd = !this.dialogAdd;
          this.update = true;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async viewItem({ id }) {
      try {
        const { data } = await this.$http.get(`quotation_detail/${id}`);
        if (data.status) {
          this.form = data.data;
          this.dialog = !this.dialog;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async submitForm() {
      const body = {
        id: this.form.id,
        note: this.form.note,
        update: this.update,
        customer_id: this.form.customer_id,
        include_tax: this.form.include_tax,
        expiry_date: this.form.expiry_date,
        currency: this.form.currency,
        document: this.form.document.value,
      };
      this.dialogAdd = !this.dialogAdd;
      this.SET_NEW_QUOTATION(body);
      this.defineStore.deleteCart();
      await this.getQuotationCart();
      // sale
      this.$router.push({ name: "sale" });
    },
    async btnAction(val) {
      try {
        const body = {
          id: this.form.id,
          status: val,
        };
        const { data } = await this.$http.post("quotation_status", body);
        if (data.status) {
          this.dialog = !this.dialog;
          await success(this, data.message);
          await this.fetchItem();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getQuotationCart() {
      const id = this.form.id;
      const { data } = await this.$http.get(`quotation_cart/${id}`);
      if (data.status) {
        const cart = data.data.map((e) => {
          const cartItem = {
            id: e.product_id.id,
            qty: e.quantity,
            discount: 0,
            price: e.product_id.price_sale * e.quantity,
            item: e.product_id,
          };

          // Handle variations if product has them
          if (
            e.product_id.has_variations &&
            e.product_id.variations &&
            e.product_id.variations.length > 0
          ) {
            // For quotation cart, we need to handle the case where variation options might not be selected
            // We'll use the base product price and stock for now
            // In a more complex scenario, you might want to store selected variation options in quotation details
            console.warn(
              "Product from quotation has variations but no specific options selected. Using base product data."
            );
          }

          return cartItem;
        });
        this.defineStore.setCart(cart);
      }
    },
  },
};
</script>

<style scoped>
.ps-doc-title {
  font-size: 1.25rem;
  font-weight: 900;
  color: #141021;
}

.ps-dark-mode-value {
  color: #ffffff;
}

.btn-primary-brand {
  background-color: #5b39c9 !important;
  color: #ffffff !important;
  border-radius: 8px !important;
  font-weight: 700 !important;
}

.btn-primary-brand:hover {
  background-color: #4f2fb9 !important;
}
</style>
